import React from "react";
import "./Flights.css";
import img5 from "../images/img5.jpg";

const Flights = () => {
  return (
    <div className="flights">
      <div className="flights-content">
        <div className="flights-content1">
          <h2>Choose your type of flight according to your desires:</h2>
        </div>
        <img src={img5} alt="" />
      </div>
    </div>
  );
};

export default Flights;
